import { MouseEventHandler, ReactNode, Ref } from 'react';

import Switch, { type SwitchCommonProps, type WithLabel, type WithHint } from 'components/shared/Switch';
import { AllOrNothing } from 'utils/types';

type SwitchFormInputProps = {
  checked: unknown;
  children: ReactNode;
  fieldTipsRef: Ref<HTMLDivElement>;
  isError: boolean;
  name: string;
  onBlur: () => void;
  onChange: (value: string) => void;
  onFocus: () => void;
  placeholder: string;
  render: unknown;
  value: string;
  trueValue?: any;
  falseValue?: any;
  onClick?: MouseEventHandler;
};

function SwitchInput(props: SwitchCommonProps & WithLabel & AllOrNothing<WithHint> & SwitchFormInputProps) {
  const { value, onChange, trueValue = true, falseValue = undefined, ...restProps } = props;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { checked, children, fieldTipsRef, isError, placeholder, render, onClick, ...fallThroughProps } = restProps;

  return (
    <Switch
      active={value === trueValue}
      onClick={(e) => {
        if (onClick) onClick(e);
        onChange(value === trueValue ? falseValue : trueValue);
      }}
      {...fallThroughProps}
    />
  );
}

export default SwitchInput;
